




























import { Vue, Component } from 'vue-property-decorator'
import List from './components/list.vue'
import CardChart from './components/cardChart.vue'
import { economyIndexList } from '@/api/economyIndex'
import { TableRowInfoList } from '@/types/tenant/dataPage'
import { cloneDeep } from 'lodash'
@Component({
  components: {
    List,
    CardChart

  }
})
export default class EconomyIndex extends Vue {
    activeName = 'first'
    data = {
      economicIndicatorInfoList: []
    }

    created () {
      this.geteConomyIndexList()
    }

    private async geteConomyIndexList () {
      const { data } = await economyIndexList({
        id: this.$route.query.id
      })
      const _economicIndicatorInfoList = []
      const _data = cloneDeep(data)

      for (let i = 0; i < data.economicIndicatorInfoList.length; i++) {
        const item = (data.economicIndicatorInfoList[i] as TableRowInfoList)
        if ((item.values !== null && item.values.length >= 2) ||
         (item.ratioValues !== null && item.ratioValues.length >= 1)) {
          _economicIndicatorInfoList.push(item)
        }
      }
      _data.economicIndicatorInfoList = _economicIndicatorInfoList
      this.data = _data
    }
}
